import { TaskT } from 'ui-io/task-io/task-t'

export type DateKey =
  | 'creationTime'
  | 'lastModifiedTime'
  | 'lastNoteTime'
  | 'scheduledTime'
const dateExtractors: Record<
  DateKey,
  (task: TaskT) => Date | undefined | null
> = {
  creationTime: (task: TaskT) => task.creationTime,
  lastModifiedTime: (task: TaskT) => task.lastModifiedTime,
  lastNoteTime: (task: TaskT) => task.lastNoteTime,
  scheduledTime: (task: TaskT) => task.scheduledTime,
}

export default dateExtractors
